import React, { useEffect, useState } from "react";
import { subscribeLoading } from "../utils/loadingBus";
import "./LoadingOverlay.css";

/**
 * Full-screen loading indicator for in-flight axios requests.
 * Shows only after a short delay so fast calls do not flash.
 */
export default function LoadingOverlay({
  message = "กำลังโหลดข้อมูล...",
  delayMs = 180,
}) {
  const [busy, setBusy] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let showTimer = null;
    const unsub = subscribeLoading((isBusy) => {
      setBusy(isBusy);
      if (isBusy) {
        if (!showTimer) {
          showTimer = setTimeout(() => {
            setVisible(true);
            showTimer = null;
          }, delayMs);
        }
      } else {
        if (showTimer) {
          clearTimeout(showTimer);
          showTimer = null;
        }
        setVisible(false);
      }
    });
    return () => {
      if (showTimer) clearTimeout(showTimer);
      unsub();
    };
  }, [delayMs]);

  if (!busy || !visible) return null;

  return (
    <div className="kpru-loading" role="status" aria-live="polite" aria-busy="true">
      <div className="kpru-loading__card">
        <span className="kpru-loading__spinner" aria-hidden="true" />
        <p className="kpru-loading__text">{message}</p>
      </div>
    </div>
  );
}

/** Compact inline spinner for selects / panels */
export function InlineLoading({ label = "กำลังโหลด..." }) {
  return (
    <div className="kpru-loading-inline" role="status" aria-live="polite">
      <span className="kpru-loading__spinner kpru-loading__spinner--sm" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
